import { perthNowNGNTextMixin } from '../../../mixins/TextMixin/TextMixin.theme'

const { title, label, body } = perthNowNGNTextMixin

export const PNArticleCardTheme = {
    '2XL': {
        tag: label['M']?.medium,
        headLine: title['2XL']?.bold,
        teaser: body['L']?.regular,
        kicker: label['M']?.medium,
        topic: label['M']?.semibold,
        time: label['M']?.regular,
        comment: label['M']?.medium,
        horizontalGridImageColumns: {
            imageMode: {
                left: 'minmax(auto, 277px) 1fr',
                right: '1fr minmax(auto, 277px)',
            },
        },
    },
    XL: {
        tag: label['M']?.medium,
        headLine: title['XL']?.bold,
        teaser: body['L']?.regular,
        kicker: label['M']?.medium,
        topic: label['M']?.semibold,
        time: label['M']?.regular,
        comment: label['M']?.medium,
        horizontalGridImageColumns: {
            imageMode: {
                left: 'minmax(auto, 238px) 1fr',
                right: '1fr minmax(auto, 238px)',
            },
        },
    },
    L: {
        tag: label['M']?.medium,
        headLine: title['L']?.bold,
        teaser: body['M']?.regular,
        kicker: label['M']?.medium,
        topic: label['M']?.semibold,
        time: label['M']?.regular,
        comment: label['M']?.medium,
        horizontalGridImageColumns: {
            imageMode: {
                left: 'minmax(auto, 199px) 1fr',
                right: '1fr minmax(auto, 199px)',
            },
        },
    },
    M: {
        tag: label['M']?.medium,
        headLine: title['M']?.bold,
        teaser: body['S']?.regular,
        kicker: label['M']?.medium,
        topic: label['M']?.semibold,
        time: label['M']?.regular,
        comment: label['M']?.medium,
        horizontalGridImageColumns: {
            imageMode: {
                left: 'minmax(auto, 194px) 1fr',
                right: '1fr minmax(auto, 194px)',
            },
        },
    },
    S: {
        tag: label['M']?.medium,
        headLine: title['S']?.bold,
        teaser: body['S']?.regular,
        kicker: label['S']?.medium,
        topic: label['S']?.semibold,
        time: label['S']?.regular,
        comment: label['S']?.medium,
        horizontalGridImageColumns: {
            imageMode: {
                left: 'minmax(auto, 160px) 1fr',
                right: '1fr minmax(auto, 160px)',
            },
        },
    },
    XS: {
        tag: label['M']?.medium,
        headLine: title['XS']?.bold,
        teaser: body['S']?.regular,
        kicker: label['M']?.medium,
        topic: label['S']?.semibold,
        time: label['S']?.regular,
        comment: label['S']?.medium,
        horizontalGridImageColumns: {
            imageMode: {
                left: 'minmax(auto, 122px) 1fr',
                right: '1fr minmax(auto, 122px)',
            },
        },
    },
    '2XS': {
        tag: label['M']?.medium,
        headLine: title['2XS']?.bold,
        teaser: body['S']?.regular,
        kicker: label['M']?.medium,
        topic: label['S']?.semibold,
        time: label['S']?.regular,
        comment: label['S']?.medium,
        horizontalGridImageColumns: {
            imageMode: {
                left: 'minmax(auto, 109px) 1fr',
                right: '1fr minmax(auto, 109px)',
            },
        },
    },
    '3XS': {
        tag: label['XS']?.medium,
    },
    ellipse: label['L']?.semibold,
    margins: {
        /** Extra Small: 5 */
        xs: 5,
        /** Small: 9 */
        sm: 9,
        /** Medium: 18 */
        md: 18,
        /** Large: 24 */
        lg: 24,
        /** Extra Large: 36 */
        xl: 36,
        /** Extra Extra Large: 48 */
        xxl: 48,
        /** Reset the value: useful for breakpoints */
        unset: 0,
        mobSm: 13,
        outerMargin: 20,
        gridGap: 18,
    },
}
